import { useSettingFaireDirectSignupForVisitorXP } from "@faire/deprecated-retailer-visitor-shared/settings/useSettingFaireDirectCreditForVisitor";
import { QueryParameters as FaireDirectInfoForVisitorQueryParameters } from "@faire/web-api--source/endpoints/www/api/page-data/faire-direct-info-for-visitor/get";
import { useQuery } from "@faire/web-api--source/endpoints/www/api/page-data/faire-direct-info-for-visitor/get-hooks";

import { BrandTokenOrBrandAlias } from "../faireDirectTypes";

export const useFaireDirectInfoForVisitorQuery = (
  params: BrandTokenOrBrandAlias,
  salesRepCode?: string
) => {
  const { brandToken, brandAlias } = params;
  const isFaireDirectCreditForVisitorXP =
    useSettingFaireDirectSignupForVisitorXP();

  const { data, isPending } = useQuery(
    FaireDirectInfoForVisitorQueryParameters.build({
      brandToken,
      brandAlias,
      salesRepCode,
    }),
    {
      enabled:
        isFaireDirectCreditForVisitorXP && (!!brandToken || !!brandAlias),
      staleTime: Infinity,
      refetchOnMount: false,
    }
  );

  return { data, isPending };
};
